export default "__VITE_ASSET__ba0b7911__"